function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "lock_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "lock_svg__a",
  transform: "translate(47 165)",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "lock_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "lock_svg__c",
  d: "M3 16a1 1 0 01-1-1V6a1 1 0 011-1h1V4a4 4 0 018 0v1h1a1 1 0 011 1v9a1 1 0 01-1 1zm0-1h10V6H3zm8-10V4a3 3 0 00-6 0v1zm-4 7.5v-4h2v4z"
}));

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgLock;